module.exports = __webpack_public_path__ + "f498c8b158afd98317dadab8878dedf3.jpg";